import api, { request } from '../../../../api';
import { IStore } from '../../../index';

export const updateGroupShotgunSpot = async (
  state: IStore,
  clubId: string | number,
  eventId: string | number,
  roundId: string | number,
  groupId: number,
  data: {
    startingHole: number;
    startingPosition: string;
  }
) => {
  const response = await request.patch(api.admin.group(clubId, eventId, roundId, groupId), data);

  if (response.error) {
    return { errors: { groups: { msg: 'Error updating the group spot' } } };
  }

  return state;
};
